<script setup lang="ts">
import appStoreBadgeCZ from "~/assets/svg/app-store-badge-cz.svg?url";
import googlePlayBadgeCZ from "~/assets/svg/google-play-badge-cz.svg?url";

const MOBILE_STORES = {
  appStore: {
    url: "https://apps.apple.com/us/app/cinestar/id6476278135",
    icon: appStoreBadgeCZ,
    title: "App Store",
  },
  googlePlay: {
    url: "https://play.google.com/store/apps/details?id=cz.cinestar.app&hl=cs&pli=1",
    icon: googlePlayBadgeCZ,
    title: "Google Play",
  },
};

type TVariant = keyof typeof MOBILE_STORES;

type TProps = {
  variant: TVariant;
};

const props = defineProps<TProps>();

const storeVariant = computed(() => {
  return MOBILE_STORES[props.variant] ?? MOBILE_STORES.googlePlay;
});
</script>

<template>
  <a :href="storeVariant.url" target="_blank">
    <img
      :src="storeVariant.icon"
      class="h-10 lg:h-11 w-auto transition-transform hover:scale-105"
      :alt="storeVariant.title"
    />
  </a>
</template>
